import { I18n } from 'i18n-js';

import { en } from '@/i18n/locales/en';
import { ja } from '@/i18n/locales/ja';

interface TranslateOptions {
  defaultValue?: string;
  count?: number;
  [key: string]: unknown;
}

interface I18nInstance {
  t: (key: string, options?: TranslateOptions) => string;
  getLocale: () => string;
  setLocale: (locale: string) => void;
}

const SUPPORTED_LOCALES = ['en', 'ja'] as const;
const DEFAULT_LOCALE = 'en';

const resolveLocale = (languageCode: string): string => {
  const match = SUPPORTED_LOCALES.find((locale) => locale === languageCode);

  return match ?? DEFAULT_LOCALE;
};

const createI18n = (initialLocale: string): I18nInstance => {
  const i18n = new I18n({ en, ja });
  i18n.defaultLocale = DEFAULT_LOCALE;
  i18n.enableFallback = true;
  i18n.locale = resolveLocale(initialLocale);

  return {
    t: (key, options) => i18n.t(key, options),
    getLocale: () => i18n.locale,
    setLocale: (locale) => {
      i18n.locale = resolveLocale(locale);
    },
  };
};

export { createI18n, DEFAULT_LOCALE, resolveLocale, SUPPORTED_LOCALES };
export type { I18nInstance };
